import axios, { AxiosRequestConfig } from 'axios'

export const isRequestCancelled = (e: Error) => axios.isCancel(e)

// one arg
export function withAutoCancellation<R, A1>(
  fn: (a1: A1, config?: AxiosRequestConfig) => Promise<R>
): (a1: A1) => Promise<R>
// two arguments
export function withAutoCancellation<R, A1, A2>(
  fn: (a1: A1, a2: A2, config?: AxiosRequestConfig) => Promise<R>
): (a1: A1, a2: A2) => Promise<R>
// three arguments
export function withAutoCancellation<R, A1, A2, A3>(
  fn: (a1: A1, a2: A2, a3: A3, config?: AxiosRequestConfig) => Promise<R>
): (a1: A1, a2: A2, a3: A3) => Promise<R>
// ...

export function withAutoCancellation(fn: any) {
  let requestPending = false
  let source = axios.CancelToken.source()

  async function requester(...args: any) {
    if (requestPending) {
      source.cancel('Auto cancelled')

      source = axios.CancelToken.source()
    }

    try {
      requestPending = true

      return await fn(...args, { cancelToken: source.token })
    } catch (e) {
      throw e
    } finally {
      requestPending = false
    }
  }

  return requester
}
